// extracted by mini-css-extract-plugin
export default {"price-chart":"PriceChart_price-chart__S0ZYA"};